module.exports = __webpack_public_path__ + "static/alexis-ohanian-0e288932eda80a8c91961678d1f03a75.jpg";